import { Component } from '@angular/core';

@Component({
  selector: 'app-ressarcimento-de-valores',
  standalone: true,
  imports: [],
  template: `
    <div>
      <p>Você já precisou cancelar uma publicação no Diário Oficial de Minas Gerais ou percebeu que realizou um pagamento em duplicidade? Nessas situações, é possível solicitar o ressarcimento de valores pagos.</p>
      <p>Quer entender como funciona o processo de solicitação, quais documentos são necessários e os prazos envolvidos? Leia as informações abaixo e veja como encaminhar o seu pedido de ressarcimento.</p>
    </div>
  `
})
export class RessarcimentoDeValoresComponent {

}
